export default __webpack_public_path__ + "static/media/multiplier-regular.3329d828.wav";